"use client";

import { Bell } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import { Button } from "@/components/ui/button";

import { Separator } from "@/components/ui/separator";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const messages: { id: number; title: string; content: string; time: string }[] = [
  
  {
    id: 3,
    title: "站点升级通知",
    content:
      "当前站点 ai.soraliststudio.com 将于 2026/04/30 下线，新域名为 metaapi.tech，请尽快迁移。\n" +
      "\n为了更好的服务各位客户，新站进行了一系列升级：\n" +
      "1. 价格按照人民币显示，并且可以根据您的折扣实时显示价格\n" +
      "2. 提供日志的图表，方便您来看自己的用量变化\n" +
      "3. 支持自定义邮件和 webhook 提醒，这样避免余额不足导致对线上产生影响\n" +
      "4. 测试页面也支持测试图片以及自定义请求体参数，方便调试\n" +
      "5. 支持批量设置令牌，方便您的管理",
    time: "2025-03-30",
  },
  {
    id: 2,
    title: "4月价格调整",
    content:
      "由于上游供应商成本提高，部分接口价格调整如下：\n" +
      "\n3.1 flash 相关接口：4k 接口 0.06 -> 0.07\n" +
      "3.1 pro 1k 接口：0.06 -> 0.08\n" +
      "3.1 pro 2k 接口：0.072 -> 0.09\n" +
      "3.1 pro 4k 接口：维持原价不变\n" +
      "\n新站点新增底价 claude 模型，辛苦各位老板前往新站 metaapi.tech 选购。",
    time: "2026-03-30",
  },
  { id: 1, title: "新春祝福", content: "感谢各位客户的支持，祝大家马年马到成功", time: "刚刚" },
];

export function NewsLink() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const hasAutoOpened = useRef(false);
  const { status } = useSession();

  useEffect(() => {
    if (hasAutoOpened.current) return;
    const isTokenPage = pathname?.includes("/tokenpg");
    const shown = sessionStorage.getItem("news_notification_shown");
    if (isTokenPage && status === "authenticated" && !shown) {
      hasAutoOpened.current = true;
      setOpen(true);
      sessionStorage.setItem("news_notification_shown", "true");
    }
  }, [pathname, status]);

  return (
    <>
      <div className="relative">
        <Button variant="ghost" size="icon" className="h-9 w-9" onClick={() => setOpen(true)}>
          <Bell className="h-4 w-4" />
        </Button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[90vw] sm:max-h-[90vh] w-[90vw] h-[85vh] flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-2xl">消息通知</DialogTitle>
            <DialogDescription>你有 {messages.length} 条系统消息</DialogDescription>
          </DialogHeader>
          <Separator />
          <div className="flex-1 overflow-y-auto space-y-3 py-2">
            {messages.map((msg) => (
              <Card key={msg.id}>
                <CardHeader className="py-3">
                  <div className="flex items-center justify-between">
                    <CardTitle className="text-lg">{msg.title}</CardTitle>
                    <CardDescription>{msg.time}</CardDescription>
                  </div>
                </CardHeader>
                <CardContent className="py-0">
                  <p className="text-sm text-foreground leading-relaxed whitespace-pre-line">
                    {msg.content}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
